<template>
  <div class="negocio__velo negocio__velo--encima" @click.self="$emit('cerrar')">
    <div class="negocio__modal informe">
      <header class="negocio__modal-cabecera negocio__modal-cabecera--azul">
        <h2>📊 Informe de Envíos y Trazabilidad de Lectura · {{ titulo }}</h2>
        <button class="negocio__cerrar" type="button" @click="$emit('cerrar')">&times;</button>
      </header>

      <div class="negocio__modal-cuerpo">
        <p v-if="error" class="negocio__aviso negocio__aviso--error">{{ error }}</p>
        <p v-if="filas === null && !error" class="negocio__aviso">Cargando…</p>
        <p v-else-if="filas && !filas.length" class="negocio__tenue">Todavía no se envía ninguna INFO.</p>
        <p v-if="filas && filas.length" class="informe__nota">
          «Abierto» sale de una imagen invisible del correo: algunos programas la bloquean y otros
          la cargan solos, así que es una pista. «Pidió más info» es el clic del cliente y acepta la OVI.
        </p>

        <table v-if="filas && filas.length" class="negocio__tabla negocio__tabla--bandeja informe__tabla">
          <thead>
            <tr>
              <th v-if="!unidad">Unidad</th>
              <th>Destinatario</th>
              <th>Email</th>
              <th>Tipo Envío</th>
              <th>Fecha / Hora</th>
              <th class="negocio__centro">Apertura</th>
              <th class="negocio__centro">Pidió más info</th>
              <th class="negocio__centro">Descargas</th>
              <th class="negocio__centro">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in filas" :key="f.id">
              <td v-if="!unidad">
                <button class="negocio__enlace" type="button" @click="$emit('ficha', f.unidad.id)">
                  {{ f.unidad.cliente }} &amp; {{ f.unidad.terreno }}
                </button>
              </td>
              <td><strong>{{ f.nombre }}</strong></td>
              <td class="informe__email">{{ f.email }}</td>
              <td>
                <span class="negocio__badge" :class="f.nivel === 'info3' ? 'negocio__badge--ambar' : 'informe__badge--azul'" :title="f.asunto">
                  {{ f.nivel_nombre }}
                </span>
              </td>
              <td class="informe__fecha">
                {{ fechaHora(f.enviado || f.fecha) }}
                <small v-if="f.enviado_por">por {{ f.enviado_por }}</small>
              </td>
              <td class="negocio__centro">
                <span v-if="f.error" class="negocio__badge negocio__badge--rojo" :title="f.error">✕ No salió</span>
                <span v-else-if="f.abierto" class="negocio__badge negocio__badge--ok" :title="`Primera apertura: ${fechaHora(f.abierto)}`">
                  ✓ Abierto{{ f.aperturas > 1 ? ` (${f.aperturas})` : '' }}
                </span>
                <span v-else class="negocio__badge">Sin abrir</span>
              </td>
              <td class="negocio__centro">
                <span v-if="f.clic" class="negocio__badge negocio__badge--ok" :title="fechaHora(f.clic)">✓ OVI {{ fecha(f.clic) }}</span>
                <span v-else class="negocio__tenue">—</span>
              </td>
              <td class="negocio__centro">{{ f.descargas || '—' }}</td>
              <td class="negocio__centro">
                <button
                  class="negocio__boton negocio__boton--chico negocio__boton--gris"
                  type="button"
                  :disabled="ocupado"
                  @click="reenviar(f)"
                >Reenviar</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="negocio__pie">
          <button class="negocio__boton negocio__boton--gris" type="button" @click="$emit('cerrar')">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mensajeError, negocioEnvios, negocioEnviosCategoria, negocioReenviar,
} from '../../services/comandoApi';

const FECHA = new Intl.DateTimeFormat('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
const FECHA_HORA = new Intl.DateTimeFormat('es-CL', { dateStyle: 'short', timeStyle: 'short' });

// El informe de una unidad (desde su ficha o su menú) o de toda la categoría (sub-barra).
export default {
  name: 'InformeEnvios',

  props: {
    unidad: { type: Number, default: null },
    categoria: { type: Number, default: null },
    titulo: { type: String, required: true },
  },

  emits: ['cerrar', 'ficha'],

  data() {
    return { filas: null, error: '', ocupado: false };
  },

  mounted() {
    this.cargar();
  },

  methods: {
    async cargar() {
      try {
        this.filas = this.unidad
          ? (await negocioEnvios(this.unidad)).destinatarios
          : await negocioEnviosCategoria(this.categoria);
      } catch (e) {
        this.error = mensajeError(e);
      }
    },

    async reenviar(fila) {
      if (!window.confirm(`¿Reenviar la ${fila.nivel_nombre} a ${fila.nombre} <${fila.email}>?`)) return;
      this.ocupado = true;
      this.error = '';
      try {
        await negocioReenviar(fila.id);
        await this.cargar();
      } catch (e) {
        this.error = mensajeError(e);
      } finally {
        this.ocupado = false;
      }
    },

    fecha(valor) {
      return valor ? FECHA.format(new Date(valor)) : '—';
    },

    fechaHora(valor) {
      return valor ? FECHA_HORA.format(new Date(valor)) : '—';
    },
  },
};
</script>
